import { BillingProduct } from "@alch/protobufs-es/billing/billing_core_pb";
import z$1 from "zod";
//#region src/usage.ts
const UsageProductSchema = z$1.enum([
	"http",
	"webSockets",
	"webhooks",
	"grpc"
]);
const UsageActionUnit = z$1.enum(["USD", "CU"]);
const UsageCapMetric = z$1.nativeEnum({
	SUPERNODE_CU: BillingProduct.SUPERNODE_CU,
	ALL_PRODUCTS: BillingProduct.ALL_PRODUCTS
});
const DEFAULT_USAGE_CAP_METRIC = UsageCapMetric.enum.SUPERNODE_CU;
//#endregion
export { DEFAULT_USAGE_CAP_METRIC, UsageActionUnit, UsageCapMetric, UsageProductSchema };

//# sourceMappingURL=usage.js.map